// extracted by mini-css-extract-plugin
export default {"logoAndName":"styles_logoAndName__0IIlQ","logoImg":"styles_logoImg__ulI15","logoText":"styles_logoText__Uu25b"};